class DropdownDirective {
    constructor($document, $rootScope, $window) {
        this.restrict = 'A';
        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.targetBoundingBox = {};
    }

    link(scope, element, attrs, controllers) {
        const targetId = attrs.targetId;
        const fallbackUrl = attrs.fallbackUrl || null;
        const triggers = attrs.triggers || 'click';
        let hides = attrs.hides || null;
        const supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;
        const parent = element.parent();

        if (!targetId || targetId == '') {
            console.error('DropdownDirective::noTarget');
            return;
        }

        const target = document.getElementById(targetId);

        if (!target) return;

        const $target = angular.element(target);

        $target.removeClass('open');
        element.removeClass('dropdown-open');

        if (hides) {
            hides = document.getElementById(hides);
            if(hides) {
                hides = angular.element(hides);
            }
        }

        let isOpen = false;

        const isMobile = () => supportsMatchMedia && this.$window.matchMedia("(max-width: 960px)").matches;

        const openOnClick = (e) => {
            if (triggers.indexOf('click') < 0 && !isMobile()) return;

            e.stopPropagation();

            if (isMobile() && fallbackUrl) {
                this.$window.location.href = fallbackUrl;
                return;
            }
            
            if (isMobile() && !isOpen) {
                e.preventDefault();
            }

            $target.toggleClass('open');
            element.toggleClass('dropdown-open');
            isOpen = !isOpen;

            if (!isOpen) return;

            this.$rootScope.$broadcast('dropdown-open', targetId);
        };

        element.on('click', openOnClick);

        const openOnMouseEnter = (e) => {
            if (triggers.indexOf('mouseenter') < 0) return;

            if (isMobile()) return;

            if (isOpen) return;

            e.stopPropagation();
            
            $target.addClass('open');
            element.addClass('dropdown-open');
            isOpen = true;

            this.$rootScope.$broadcast('dropdown-open', targetId);

            if (hides) {
                const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
                    return p.toString() === "[object SafariRemoteNotification]";
                })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

                if (isSafari) {
                    let hidesBoundingRect = hides[0].getBoundingClientRect();
                    let targetBoundingRect = $target[0].getBoundingClientRect();

                    this.targetBoundingBox = {
                        minX: Math.min(hidesBoundingRect.x, targetBoundingRect.x),
                        minY: Math.min(hidesBoundingRect.y, targetBoundingRect.y),
                        maxX: hidesBoundingRect.x + hidesBoundingRect.width,
                        maxY: targetBoundingRect.bottom
                    }

                    document.removeEventListener('mousemove', hideOnMouseOutsideTarget);
                    document.addEventListener('mousemove', hideOnMouseOutsideTarget);
                } else {
                    hides.off('mouseleave');
                    hides.on('mouseleave', (e) => {
                        hides.off('mouseleave');
                        hideOnMouseLeave(e);
                    });
                }
            }
        };

        const hideOnMouseOutsideTarget = (e) => {
            if (e.clientX > this.targetBoundingBox.maxX ||
                e.clientX < this.targetBoundingBox.minX ||
                e.clientY < this.targetBoundingBox.minY ||
                e.clientY > this.targetBoundingBox.maxY) {
                document.removeEventListener('mousemove', hideOnMouseOutsideTarget);
                hideOnMouseLeave(e);
            }
        }

        const hideOnMouseLeave = (e) => {
            if (triggers.indexOf('mouseenter') < 0) return;

            if (isMobile()) return;

            if (!isOpen)
                return;

            $target.removeClass('open');
            element.removeClass('dropdown-open');
            isOpen = false;
        };
        
        element.on('mouseenter', openOnMouseEnter);

        if(!hides) {
            parent.on('mouseleave', hideOnMouseLeave);
        }

        const documentClickOutside = (e) => {
            if (!isOpen)
                return;

            if (element !== e.target && $target !== e.target && !$target[0].contains(e.target)) {
                $target.removeClass('open');
                element.removeClass('dropdown-open');
                isOpen = false;
            }
        };

        this.$document.on('click', documentClickOutside);

        this.$rootScope.$on('dropdown-open', function(event, id) {
            if (targetId === id) return;

            $target.removeClass('open');
            element.removeClass('dropdown-open');
            isOpen = false;
        });

        scope.$on('$destroy', () => {
            element.on('click', openOnClick);
            element.off('mouseenter', openOnMouseEnter);
            parent.off('mouseleave', hideOnMouseLeave);
            this.$document.off('click', documentClickOutside);
        });
    }

    static directiveFactory($document, $rootScope, $window) {
        'ngInject';
        return new DropdownDirective($document, $rootScope, $window);
    }
}

export default DropdownDirective;
